import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      Welcome: 'Welcome to React and react-i18next',
      validations: {
        weak: 'Weak Passwoed',
        user: 'Username Wrong',
        phoneNo: 'phoneNo Wrong',
        required: 'Required'
      }
    }
  },
  ar: {
    translation: {
      Welcome: 'مرحبا بك',
      validations: {
        weak: 'كملة المرور ضعيفة',
        user: 'اسم المستخدم خاطئ',
        phoneNo: ' رقم الهاتف خاطئ',
        required: 'مطلوب'
      }
    }
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'en',

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
